import React from "react"
import { NavLink } from "react-router-dom"

import * as Icons from "../assets/icons"

const Tile = ({ image, name, url, text }) => (
  <NavLink to={url} className="card">
    <div className="card-image" style={{ backgroundImage: `url(${image})` }} />
    <div className="card-body">
      <h3 className="card-title">{name}</h3>
      {text && <p className="card-text">{text}</p>}
      <span className="card-more">
        Dowiedz się więcej <Icons.ArrowRight />
      </span>
    </div>
  </NavLink>
)

export default Tile
